export function trimNonEmpty(value) {
  if (value == null || typeof value !== 'string') return '';
  return value.trim();
}

export function stripHtml(html, max = 320) {
  if (!html || typeof html !== 'string') return '';
  return html
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, max);
}

export function documentTitle(seoTitle, title, fallback) {
  const base = trimNonEmpty(seoTitle) || trimNonEmpty(title) || trimNonEmpty(fallback);
  if (!base) return 'Charlee.ai';
  if (/\|\s*Charlee\.ai\s*$/i.test(base)) return base;
  return `${base} | Charlee.ai`;
}

export function metaDescriptionFromRecord({
  metaDescription,
  description,
  body,
  title,
  fallback,
}) {
  return (
    trimNonEmpty(metaDescription) ||
    stripHtml(description) ||
    stripHtml(body) ||
    trimNonEmpty(title) ||
    trimNonEmpty(fallback) ||
    'Charlee.ai'
  );
}
